export default {
  default: {
    title: 'Integration Partner',
    getStarted: 'Get Started',
  },
}
